import {
  DelimitedArrayParam,
  NumberParam,
  type QueryParamConfigMap,
  StringParam,
  withDefault
} from 'serialize-query-params';

import { OrganizationRequestDTO } from '@/api/generated';
import { DEFAULT_PAGINATION, DEFAULT_SORTING, getEmptyDate } from '@/hooks/useEntityList';

export const COMPOUND_FORM_VALUE_KEYS = ['organization.createdAt', 'organization.lastActivity'];

export const DEFAULT_VALUES = {
  organization: {
    status: null,
    office: null,
    createdAt: getEmptyDate(),
    lastActivity: getEmptyDate()
  },
  ...DEFAULT_SORTING,
  ...DEFAULT_PAGINATION
} as unknown as OrganizationRequestDTO; // FIXME: Use the actual type

export const URL_CONFIG_MAP = {
  office: StringParam,
  'organization.status': DelimitedArrayParam,
  'organization.createdBy': DelimitedArrayParam,
  'organization.industry': DelimitedArrayParam,
  size: withDefault(NumberParam, DEFAULT_PAGINATION.size)
} as QueryParamConfigMap;
